import getMessage, { PhraseTranslationKeys } from './get-message';

const findVars = /(\{[\S]+\})/g;

type Args = { [key: string]: string };

function translate(id: PhraseTranslationKeys, args: Args = {}, fallback?: PhraseTranslationKeys): string {
    const str = getMessage(id);
    if (str === undefined || str == null) {
        if (fallback) {
            try {
                const fallbackTranslation = getMessage(fallback);
                return fallbackTranslation || '';
            } catch {
                return id;
            }
        }
        return id;
    }
    // 'a string with {a} variable' -> ['a string with ', '{a}', ' variable']
    const segments = str.split(findVars).filter(a => a);
    const response = segments.map(segment => {
        if (segment.startsWith('{')) {
            // '{var}' -> 'var'
            const key = segment.replace('{', '').replace('}', '');
            return args[key] !== undefined ? args[key] : segment;
        } else {
            return segment;
        }
    });

    return response.join('');
}

export default translate;
